import React from "react";
import { Link, useLocation } from "react-router";
import { cn } from "@/lib/utils";
import LoginButton from "./LoginButton";
import zMarkImg from "../assets/z_mark.png";

const navItems = [
  { path: "/projects", label: "Projects" },
  { path: "/kilns", label: "Kilns" },
  { path: "/inventory", label: "Inventory" },
  { path: "/tools", label: "Tools" },
];

const Header = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <div role="navigation" className="flex items-center border-b border-border mb-6 py-3">
      <Link to="/" className="flex items-center gap-2 mr-6">
        <img src={zMarkImg} alt="" className="h-[34px] w-auto" />
        <span className="text-xl font-bold text-brand-navy">Kiln Helper</span>
      </Link>

      <nav className="flex items-center">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "px-3 py-2 text-sm font-medium transition-colors border-b-2 -mb-[1px]",
              isActive(item.path)
                ? "border-primary text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground"
            )}
          >
            {item.label}
          </Link>
        ))}
      </nav>

      <div className="ml-auto shrink-0">
        <LoginButton />
      </div>
    </div>
  );
};

export default Header;
